export const FETCH_RECEIVEPAYMENT_REQUEST = "FETCH_RECEIVEPAYMENT_REQUEST";
export const FETCH_RECEIVEPAYMENT_SUCCESS = "FETCH_RECEIVEPAYMENT_SUCCESS";
export const FETCH_RECEIVEPAYMENT_FAILURE = "FETCH_RECEIVEPAYMENT_FAILURE";
